import { render, staticRenderFns } from "./GroupPlanSelectFromCopays.vue?vue&type=template&id=48b390d6&lang=pug"
import script from "./GroupPlanSelectFromCopays.vue?vue&type=script&lang=js"
export * from "./GroupPlanSelectFromCopays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports